<template>
  <div class="m-grid__item m-grid__item--fluid m-wrapper">
    <div class="m-subheader ">
      <div class="d-flex align-items-center">
        <div class="mr-auto">
          <h3 class="m-subheader__title ">

          </h3>
        </div>
      </div>
    </div>
    <div class="m-content">
      <div class="about-margin m--padding-30 text-center">
        <div class="panel-title">
          <span class="">
            <img class="navbar-brand-logo" src="../../../static/img/makueni-logo.png" title="Kitui logo">
          </span>
        </div>
        <div class="m-portlet__body">
          <p>Version: 1.2.0 </p>
          <p>&copy; {{ (new Date()).getFullYear() }} ZIZI. All rights reserved.</p>
          <p>ZIZI
            <router-link to="/terms">Terms of Service</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import helpers from "../../helpers";

export default {
  name: "about",
  mounted: function() {
    helpers.resetItems();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/About.vue